/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import CreditCheck from '../../../../components/Web/CreditCheck/redesign/index';
import * as creditCheckActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import creditCheck from '../../reducer';
import cartSaga from '../../../../services/Cart/sagas';
import creditStatusSaga from '../../../CreditStatus/sagas';
import * as cartActions from '../../../../services/Cart/actions';
import * as CreditCheckSelectors from '../../selectors/creditCheckSelectors';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import { checkPlanReferenceData } from '../../../../utils/plansReference';
import { universalProfileBannerDisplayed } from '../../../ContactInfo/actions';

const mapStateToProps = (state) => {
  const CreditCheckSelector = CreditCheckSelectors.selectData(state);
  const cartDetails = state.cartDetails || {};
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo;
  //   const setupType = cartDetails && cartDetails.cartDetailsJson && cartDetails.cartDetailsJson.orderDetailsView.installType.indexOf('Prof') > -1 ? 'Prof' : 'Self';
  const orderDetails = cartDetails?.cartDetailsJson?.orderDetailsView || {};
  //   const creditHoldResponse = getCreditHoldResponse(state.cartDetails);
  //   const validateOrder = getValidateOrder(state.cartDetails);
  //   const isCreditStatusAvailable = creditHoldResponse || validateOrder.downpaymentRequired || validateOrder.errorMessage !== '';
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const creditReviewSuccess = state.creditCheckDetails?.creditReviewSuccess;
  const creditCheckStateAddress = state.creditCheckDetails?.creditCheckAddressFail;
  const creditCheckApiError = state.creditCheckDetails?.showCreditCheckError;
  const creditCheckServiceDetails = state.creditCheckDetails?.creditCheckServiceDetails;
  const shippingInfoState = state.shippingInfo;
  const ShippingInfoDetails = state.shippingInfo?.ShippingInfoDetails;
  const showZipcodeError = state.creditCheckDetails?.showZipcodeError;
  const ccInvalidCaseError = state.creditCheckDetails?.ccInvalidCaseError;
  const eidQuestionsFromCreditStatus = state.creditStatus?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.eidQuestionnaire;
  const retrieveCartAPIStatus = cartDetails?.apiStatus;
  const loaderStatus = state?.loader?.loaderStatus;
  const creditCheckError = state.creditCheckDetails?.creditCheckError || false;
  const creditCheckNtfyMsg = state.creditCheckDetails?.creditCheckNtfyMsg || null;
  const apiLoaded = state.SessionValues?.apiLoaded;
  //   const currentView = state.currentView || {};
  const {
    isUniversalProfileSuccessBannerDisplayed,
    isUniversalProfileCreated,
    universalProfileCreationStatus,
    universalProfileCreationBannerMessages,
  } = state.contactInfo || {};

  return {
    CreditCheckSelector,
    cartDetails,
    creditCheckStateAddress,
    //     setupType,
    //     currentView,
    orderDetails,
    plansReferenceData,
    creditReviewSuccess,
    creditCheckApiError,
    creditCheckServiceDetails,
    shippingInfoState,
    ShippingInfoDetails,
    showZipcodeError,
    creditReviewSuccessResponse,
    ccInvalidCaseError,
    eidQuestionsFromCreditStatus,
    retrieveCartAPIStatus,
    loaderStatus,
    creditCheckError,
    creditCheckNtfyMsg,
    //     isCreditStatusAvailable,
    isUniversalProfileSuccessBannerDisplayed,
    isUniversalProfileCreated,
    universalProfileCreationStatus,
    universalProfileCreationBannerMessages,
    apiLoaded,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...creditCheckActions, ...cartActions, ...taggingActions, universalProfileBannerDisplayed }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'creditCheck', reducer: creditCheck }));

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withSaga = compose(
  injectSaga({ key: 'creditCheck', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'creditStatus', saga: creditStatusSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  // injectSaga({ key: 'shippingInfo', saga: shippingInfo}),
);

export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(CreditCheck),
);
